export default __webpack_public_path__ + "static/media/muted.3c154fda.svg";